/**
 * Endorse v3 theme runtime.
 * Ports Reveal (IntersectionObserver fade-up) and Counter (count-up on viewport entry)
 * from the Next shop's components, plus a small init hook for the header dropdown nav.
 */
(function () {
  'use strict';

  /* ===== Reveal: any [data-reveal] gets .in once intersecting ===== */
  function initReveal() {
    var els = document.querySelectorAll('[data-reveal]');
    if (!els.length || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('in'); });
      return;
    }
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('in');
          obs.unobserve(e.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { obs.observe(el); });
  }

  /* ===== Counter: [data-counter] elements count from 0 → data-to on intersect ===== */
  function initCounters() {
    var els = document.querySelectorAll('[data-counter]');
    if (!els.length) return;

    var animate = function (el) {
      var to = parseInt(el.getAttribute('data-to') || '0', 10);
      var prefix = el.getAttribute('data-prefix') || '';
      var suffix = el.getAttribute('data-suffix') || '';
      var duration = parseInt(el.getAttribute('data-duration') || '1500', 10);
      var start = performance.now();
      var tick = function (now) {
        var t = Math.min(1, (now - start) / duration);
        var eased = 1 - Math.pow(1 - t, 3);
        el.textContent = prefix + Math.round(eased * to) + suffix;
        if (t < 1) requestAnimationFrame(tick);
      };
      requestAnimationFrame(tick);
    };

    if (!('IntersectionObserver' in window)) {
      els.forEach(animate);
      return;
    }
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting && !e.target.dataset.counted) {
          e.target.dataset.counted = '1';
          animate(e.target);
          obs.unobserve(e.target);
        }
      });
    }, { threshold: 0.4 });
    els.forEach(function (el) { obs.observe(el); });
  }

  /* ===== Site header: hover-dropdown mega menu + mobile slide-in + search dropdown ===== */
  function initHeader() {
    var header = document.querySelector('.site-header');
    if (!header) return;

    /* Category mega-menu */
    var items = header.querySelectorAll('[data-cat-item]');
    items.forEach(function (item) {
      var open = function () { item.setAttribute('data-open', 'true'); };
      var close = function () { item.removeAttribute('data-open'); };
      item.addEventListener('mouseenter', open);
      item.addEventListener('mouseleave', close);
      item.addEventListener('focusin', open);
      item.addEventListener('focusout', function (e) {
        if (!item.contains(e.relatedTarget)) close();
      });
    });

    /* Mobile menu */
    var mobileBtn = header.querySelector('[data-mobile-toggle]');
    var mobile = document.querySelector('[data-mobile-menu]');
    if (mobileBtn && mobile) {
      var openMobile = function () {
        mobile.removeAttribute('hidden');
        document.documentElement.style.overflow = 'hidden';
      };
      /* Underpanelet lukkes SAMMEN med skuffen. Uden det staar man naeste gang
         man aabner menuen midt i "Hudpleje" uden at have bedt om det. */
      var lukUnder = function () {
        mobile.querySelectorAll('[data-sub-panel]').forEach(function (p) { p.hidden = true; });
        mobile.querySelectorAll('[data-sub-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      };
      var closeMobile = function () {
        mobile.setAttribute('hidden', '');
        document.documentElement.style.overflow = '';
        lukUnder();
      };
      mobileBtn.addEventListener('click', openMobile);

      /* Soegeknappen i mobil-headeren aabner skuffen og saetter markoeren i dens
         soegefelt. Fokus SKAL saettes efter at skuffen er synlig — et `focus()`
         paa noget der stadig er `hidden` gaar i gulvet, og saa aabnede tastaturet
         sig ikke paa telefonen. */
      var soegBtn = header.querySelector('[data-mobile-search]');
      if (soegBtn) {
        soegBtn.addEventListener('click', function () {
          openMobile();
          var felt = mobile.querySelector('.site-header__mobile-search input');
          if (felt) requestAnimationFrame(function () { felt.focus(); });
        });
      }

      /* ===== Bor ned i en kategoris hylder =====
         Delegeret, fordi listen tegnes af Liquid i to grene og punkterne derfor
         ikke kan bindes én for én uden at de to kan komme ud af takt.

         ESCAPE tager ét niveau ad gangen: staar man i et underpanel, lukker
         foerste tryk panelet og ikke hele skuffen. Det er det Lyko og Boozt
         goer, og alternativet — at kastes helt ud af menuen fordi man ville et
         skridt tilbage — er den slags der faar folk til at lade vaere. */
      mobile.addEventListener('click', function (e) {
        var aab = e.target.closest('[data-sub-open]');
        if (aab) {
          e.preventDefault();
          var id = aab.getAttribute('data-sub-open');
          var panel = mobile.querySelector('[data-sub-panel="' + (window.CSS && CSS.escape ? CSS.escape(id) : id) + '"]');
          if (!panel) return;
          lukUnder();
          panel.hidden = false;
          aab.setAttribute('aria-expanded', 'true');
          var tilbage = panel.querySelector('[data-sub-back]');
          if (tilbage) tilbage.focus();
          return;
        }
        var tilbageKnap = e.target.closest('[data-sub-back]');
        if (tilbageKnap) {
          e.preventDefault();
          var luk = tilbageKnap.closest('[data-sub-panel]');
          var id2 = luk ? luk.getAttribute('data-sub-panel') : null;
          lukUnder();
          if (id2) {
            var knap = mobile.querySelector('[data-sub-open="' + (window.CSS && CSS.escape ? CSS.escape(id2) : id2) + '"]');
            if (knap) knap.focus();
          }
        }
      });
      mobile.querySelectorAll('[data-mobile-close]').forEach(function (el) {
        el.addEventListener('click', closeMobile);
      });
      mobile.addEventListener('click', function (e) {
        if (e.target === mobile) closeMobile();
      });
      document.addEventListener('keydown', function (e) {
        if (e.key !== 'Escape' || mobile.hasAttribute('hidden')) return;
        var aabentUnder = mobile.querySelector('[data-sub-panel]:not([hidden])');
        if (aabentUnder) { lukUnder(); return; }
        closeMobile();
      });
    }

    /* Header search dropdown + live predictive suggestions */
    /* `querySelectorAll` og ikke `header.querySelector`: feltet findes nu TO
       steder — fremme i desktop-headeren, og oeverst i mobilskuffen. Blokken
       herunder roerer kun ting den finder INDE i sit eget `search`-element, saa
       den kan koere én gang pr. felt uden at de to kan komme til at skrive i
       hinandens dropdown. Foer var forslagene desktop-only, og paa telefon var
       soegning et blindt spring til /search. */

    /* ===== SOEGEINDEKSET HENTES EN GANG =====

       loadSearch og searchReady laa foer inde i forEach over
       [data-header-search]. Der er TO af de felter: desktop-headeren
       (header.liquid:45) og mobilskuffen (header.liquid:456). To closures
       betoed to fetches af search-index.json (1,94 MB / 315 kB gzip), to
       MiniSearch.loadJS og to fulde danske tokeniseringer af 1.017
       dokumenter. Maalt paa live foer flytningen: /search hentede indekset
       to gange.

       GOLIVE-3-SEO-GEO.md kendte symptomet og gav patch-raekkefoelgen
       skylden. Det var scope, ikke raekkefoelge.

       Blokken laeser ingen per-felt-tilstand (input, dropdown, inner, seq,
       timer, activeIndex), kun window.EndorseSearch/MiniSearch/EndorseLang/
       EndorseOverlay. Derfor kan den ligge her. Laeg den ikke tilbage. */
    /* Suggestions come from a local index (assets/search-index.json) rather than
       Shopify's /search/suggest.json. Shopify's predictive endpoint only looks at
       title/type/vendor/variant, has no Danish stemming, and cannot split compounds —
       so "creme" never finds "ansigtscreme" and no ingredient is searchable at all.
       The local index covers ingredients, attributes, description and generated
       keywords, in Danish, and answers in under a millisecond with no request. */
    var searchReady = null;
    var loadSearch = function () {
      if (searchReady) return searchReady;
      var cfg = window.EndorseSearch || {};
      if (!cfg.index) return (searchReady = Promise.reject(new Error('no index')));
      var script = function (src) {
        return new Promise(function (res, rej) {
          var s = document.createElement('script');
          s.src = src; s.onload = res; s.onerror = rej;
          document.head.appendChild(s);
        });
      };
      searchReady = Promise.all([
        window.MiniSearch ? null : script(cfg.engine),
        window.EndorseLang ? null : script(cfg.lang),
        fetch(cfg.index).then(function (r) { return r.json(); }),
        window.EndorseOverlay ? window.EndorseOverlay.load() : null,
      ]).then(function (out) {
        var data = out[2];
        /* PRIS-PATCH FOER loadJS. Dropdownen render'er fra storedFields, saa den
           baerer sin egen kopi af prisen ved siden af gitterets — og search-index.json
           er lige saa gammel som sidste theme-push. Patchen skal ligge her og ikke
           efter, fordi storedFields er MiniSearchs interne tilstand naar indekset
           foerst er indlaest. Reglen selv staar i endorse-overlay.js. */
        /* `&& patchDocs` er ikke overforsigtighed (tilfoejet 2026-09-08). De to
           filer bliver ikke pushet samtidigt: da samtykke-gaten skulle live, laa
           den her linje i arbejdstraeet mens den LIVE endorse-overlay.js var den
           gamle udgave paa 5.880 tegn UDEN patchDocs. Et push af theme.js alene
           havde kastet en TypeError midt i soegningens opstart og slaaet
           dropdownen ud. Med tjekket springer patchen bare over, indtil overlayet
           ogsaa er pushet, og saa taender den af sig selv. */
        if (window.EndorseOverlay && window.EndorseOverlay.patchDocs && out[3]) {
          window.EndorseOverlay.patchDocs(data, out[3]);
        }
        var mini = window.MiniSearch.loadJS(data.index, window.EndorseLang.options());

        /* BUNDLE-OVERLAYET. Samme feed som gitteret bruger — og det SKAL være
           samme feed: søgesiden sender sine handles videre til gitteret, som
           slår dem op i sit eget byHandle, så en bundle der kun stod i
           indekset ville forsvinde lydløst fra resultatgitteret.

           discard og ikke remove: remove() kræver det oprindelige dokument
           uændret og korrumperer indekset ellers. add() kaster på et id der
           findes i forvejen, derfor has()-tjekket først.

           Tokeniseringen kommer fra EndorseLang.options() og køres her i
           browseren — samme UMD-fil som Node-builden brugte, så tokens matcher
           per konstruktion. Det er præcis derfor det er sikkert at udvide et
           færdigbygget indeks ved runtime. */
        var ov = out[3];
        /* KLADDERNE (2026-10-29). Indekset baerer varer der var kladde da det blev bygget,
           saa en aktivering ikke kraever et push. De smides ud her medmindre feedet
           bekraefter at varen er aktiv. Uden feed (ov null eller tom): alle ud. */
        if (data.kladde && data.kladde.length) {
          var akt = window.EndorseOverlay && window.EndorseOverlay.aktive ? window.EndorseOverlay.aktive(ov) : {};
          for (var kk = 0; kk < data.kladde.length; kk++) {
            var kd = data.kladde[kk];
            if (!akt[kd[1]] && mini.has(kd[0])) mini.discard(kd[0]);
          }
        }
        if (ov) {
          try {
            for (var i = 0; i < ov.docs.length; i++) {
              var doc = ov.docs[i];
              if (mini.has(doc.id)) mini.discard(doc.id);
              mini.add(doc);
            }
            for (var r = 0; r < ov.removeIds.length; r++) {
              if (mini.has(ov.removeIds[r])) mini.discard(ov.removeIds[r]);
            }
          } catch (e) {}
        }

        return { mini: mini, data: data };
      });
      return searchReady;
    };

    document.querySelectorAll('[data-header-search]').forEach(function (search) {
      var input = search.querySelector('input[type="search"]');
      var clearBtn = search.querySelector('[data-search-clear]');
      var dropdown = search.querySelector('[data-search-dropdown]');
      var inner = dropdown ? dropdown.querySelector('.site-header__search-dropdown-inner') : null;
      var MIN = 2, DEBOUNCE = 170, LIMIT = 6;
      var timer = null, controller = null, seq = 0, activeIndex = -1;

      var setOpen = function (open) {
        if (open) search.setAttribute('data-open', 'true');
        else { search.removeAttribute('data-open'); activeIndex = -1; }
      };
      var esc = function (s) {
        return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
          return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
        });
      };
      var sizedImg = function (u) { return !u ? '' : u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=100'; };
      var money = function (v) {
        var n = parseFloat(v || '0');
        if (!(n > 0)) return '';
        var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'DKK';
        try { return new Intl.NumberFormat('da-DK', { style: 'currency', currency: cur }).format(n); }
        catch (e) { return Math.round(n) + ' kr'; }
      };
      var message = function (html) { if (inner) { inner.innerHTML = html; activeIndex = -1; } };

      var productRow = function (p) {
        var price = money(p.pris);
        return '<li role="option">'
          + '<a class="site-header__search-result" href="' + esc(p.url) + '">'
            + '<span class="site-header__search-result-thumb">'
              + (p.img ? '<img src="' + esc(sizedImg(p.img)) + '" alt="" loading="lazy" width="48" height="48">' : '')
            + '</span>'
            + '<span class="site-header__search-result-text">'
              + (p.brand ? '<span class="site-header__search-result-vendor">' + esc(p.brand) + '</span>' : '')
              + '<span class="site-header__search-result-title">' + esc(p.title) + '</span>'
            + '</span>'
            + (price ? '<span class="site-header__search-result-price">' + price + '</span>' : '')
          + '</a></li>';
      };

      /* A query like "tør hud" or "vegansk" is better answered with the filtered page
         than with six products. Shortcuts are precomputed in the index and matched on the
         same processed tokens the query is reduced to. */
      var shortcutsFor = function (S, term) {
        var Lang = window.EndorseLang;
        var qTokens = {};
        Lang.tokenize(term).forEach(function (w) {
          (Lang.processTerm(w) || []).forEach(function (t) { qTokens[t] = 1; });
        });
        var out = [];
        var brandHit = (S.data.brands || []).filter(function (b) {
          var bt = Lang.processTerm(Lang.tokenize(b)[0] || '') || [];
          return bt.some(function (t) { return qTokens[t]; });
        })[0];
        if (brandHit) {
          /* ?maerke= er VORES eget filterformat (plp-filter.js, MAERKE-konstanten), ikke
             Shopifys ?filter.p.vendor=. Sidstnævnte ignoreres fuldstændig, fordi butikkens
             storefront-filtre aldrig blev slået til i Search & Discovery — genvejen landede
             derfor på /collections/all med alle produkter og intet filter. */
          out.push({ label: 'Alle produkter fra ' + brandHit,
                     url: '/collections/all?maerke=' + encodeURIComponent(brandHit) });
        }
        (S.data.genveje || []).forEach(function (g) {
          if (out.length >= 3) return;
          var all = g.tokens.every(function (t) { return qTokens[t]; });
          if (all) out.push({ label: g.label, url: g.url, antal: g.antal });
        });
        return out.slice(0, 3);
      };

      var renderResults = function (S, term) {
        if (!inner) return;
        var Lang = window.EndorseLang;
        var hits = Lang.search(S.mini, term);
        var shortcuts = shortcutsFor(S, term);

        if (!hits.length && !shortcuts.length) {
          message('<p class="site-header__search-empty">Ingen forslag til “' + esc(term) + '”. Tryk Enter for fuld søgning.</p>');
          return;
        }

        var html = '';
        if (shortcuts.length) {
          html += '<div class="site-header__search-shortcuts">' + shortcuts.map(function (s) {
            return '<a class="site-header__search-shortcut" href="' + esc(s.url) + '">' + esc(s.label)
              + (s.antal ? ' <span>(' + s.antal + ')</span>' : '') + '</a>';
          }).join('') + '</div>';
        }
        if (hits.length) {
          html += '<ul class="site-header__search-results" role="listbox">'
            + hits.slice(0, LIMIT).map(productRow).join('') + '</ul>';
        }
        html += '<a class="site-header__search-all" href="/search?q=' + encodeURIComponent(term) + '">'
          + 'Se alle ' + hits.length + ' resultater for “' + esc(term) + '” →</a>';
        inner.innerHTML = html;
        activeIndex = -1;
      };

      var runSearch = function (term) {
        var mySeq = ++seq;
        loadSearch().then(function (S) {
          if (mySeq !== seq) return;
          renderResults(S, term);
        }).catch(function () {
          if (mySeq !== seq) return;
          message('<p class="site-header__search-empty">Tryk Enter for at søge.</p>');
        });
      };

      if (input) {
        /* On a results page, show the active query in the field but muted; it
           clears the moment the field is focused so a new search starts fresh. */
        if (location.pathname.indexOf('/search') === 0) {
          try {
            var q0 = new URLSearchParams(location.search).get('q');
            if (q0) { input.value = q0; input.classList.add('is-prefilled'); }
          } catch (e) {}
        }
        input.addEventListener('input', function () {
          input.classList.remove('is-prefilled');
          var v = input.value.trim();
          if (clearBtn) clearBtn.hidden = !input.value;
          if (v.length < MIN) { setOpen(false); if (timer) clearTimeout(timer); return; }
          setOpen(true);
          if (inner && !inner.querySelector('.site-header__search-results')) {
            message('<p class="site-header__search-empty">Søger…</p>');
          }
          if (timer) clearTimeout(timer);
          timer = setTimeout(function () { runSearch(v); }, DEBOUNCE);
        });
        input.addEventListener('focus', function () {
          if (input.classList.contains('is-prefilled')) {
            input.value = '';
            input.classList.remove('is-prefilled');
          }
          // Warm the index on focus so the first keystroke already has it in memory.
          // Visitors who never open search pay nothing for it.
          loadSearch().catch(function () {});
          if (input.value.trim().length >= MIN) setOpen(true);
        });
        input.addEventListener('keydown', function (e) {
          var opts = dropdown ? dropdown.querySelectorAll('.site-header__search-result') : [];
          if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
            if (!opts.length) return;
            e.preventDefault();
            activeIndex += (e.key === 'ArrowDown' ? 1 : -1);
            if (activeIndex < 0) activeIndex = opts.length - 1;
            if (activeIndex >= opts.length) activeIndex = 0;
            for (var i = 0; i < opts.length; i++) opts[i].classList.toggle('is-active', i === activeIndex);
            opts[activeIndex].scrollIntoView({ block: 'nearest' });
          } else if (e.key === 'Enter') {
            if (activeIndex > -1 && opts[activeIndex]) {
              e.preventDefault();
              window.location.href = opts[activeIndex].getAttribute('href');
            }
          }
        });
      }
      if (clearBtn) {
        clearBtn.hidden = true;
        clearBtn.addEventListener('click', function () {
          if (input) { input.value = ''; input.focus(); }
          clearBtn.hidden = true;
          if (timer) clearTimeout(timer);
          if (controller) { try { controller.abort(); } catch (e) {} }
          setOpen(false);
        });
      }
      document.addEventListener('click', function (e) {
        if (!search.contains(e.target)) setOpen(false);
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') { setOpen(false); if (input) input.blur(); }
      });
    });

    /* Resultatside-blokken laa ogsaa inde i forEach, men slaar op med
       document.querySelector — altsaa dokument-niveau. Den koerte derfor en
       gang PR. SOEGEFELT og udsendte endorse:results to gange paa /search.
       Nu koerer den en gang, og den koerer ogsaa hvis headeren slet ikke har
       et soegefelt. */
    /* The results page runs on the SAME local index as the dropdown. It used to be
       Shopify's own search, which meant the dropdown promised "465 resultater for tør
       hud" and the page then showed 2 — Shopify has no Danish stemming, cannot split
       compounds and never looks at metafields. Now the dropdown's count and the page's
       results are by construction the same thing, and the filter bar filters them. */
    var results = document.querySelector('[data-search-results]');
    if (results) {
      var term = results.getAttribute('data-term') || '';
      var plpRoot = results.closest('[data-plp]');
      if (term && plpRoot) {
        loadSearch().then(function (S) {
          var hits = window.EndorseLang.search(S.mini, term);
          plpRoot.setAttribute('data-search-done', '1');
          plpRoot.dispatchEvent(new CustomEvent('endorse:results', {
            detail: { handles: hits.map(function (h) { return String(h.url).replace('/products/', ''); }) },
          }));
        }).catch(function () { plpRoot.setAttribute('data-search-failed', '1'); });
      }
    }
  }

  /* ===== Filter + sort bar (shared by the collection PLP and search page) ===== */
  /* Exposed so assets/plp-filter.js can re-init the slider after it recalculates the
     price ceiling for the current filter combination. */
  function initPriceSlider(slider) {
    var max = parseInt(slider.getAttribute('data-max'), 10) || 0;
    var minI = slider.querySelector('[data-slider-min]');
    var maxI = slider.querySelector('[data-slider-max]');
    var fill = slider.querySelector('[data-slider-fill]');
    var form = slider.closest('form');
    var lblMin = form && form.querySelector('[data-slider-lbl-min]');
    var lblMax = form && form.querySelector('[data-slider-lbl-max]');
    if (!minI || !maxI) return;
    function pct(v) { return max > 0 ? (v / max * 100) : 0; }
    function update() {
      var a = parseInt(minI.value, 10), b = parseInt(maxI.value, 10);
      if (fill) { fill.style.left = pct(a) + '%'; fill.style.right = (100 - pct(b)) + '%'; }
      if (lblMin) lblMin.textContent = a + ' kr';
      if (lblMax) lblMax.textContent = b + ' kr';
      minI.style.zIndex = a > max / 2 ? 5 : 3; /* keep the top-end handle grabbable */
    }
    minI.addEventListener('input', function () {
      if (parseInt(minI.value, 10) > parseInt(maxI.value, 10)) minI.value = maxI.value;
      update();
    });
    maxI.addEventListener('input', function () {
      if (parseInt(maxI.value, 10) < parseInt(minI.value, 10)) maxI.value = minI.value;
      update();
    });
    update();
  }

  function initFilterBars() {
    document.querySelectorAll('[data-plp]').forEach(function (root) {
      if (!root.querySelector('.plp__filterbar')) return;
      var esc = function (s) { return (window.CSS && CSS.escape) ? CSS.escape(s) : s.replace(/([^\w-])/g, '\\$1'); };
      function closeAll() {
        root.querySelectorAll('.plp__fgroup, .plp__sortgroup').forEach(function (g) { g.classList.remove('is-open'); });
        root.querySelectorAll('[data-filter-drop],[data-sort-drop]').forEach(function (d) { d.hidden = true; });
      }
      root.querySelectorAll('[data-filter-toggle]').forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.stopPropagation();
          var id = btn.getAttribute('data-filter-toggle');
          var grp = btn.closest('.plp__fgroup');
          var drop = root.querySelector('[data-filter-drop="' + esc(id) + '"]');
          var isOpen = drop && !drop.hidden;
          closeAll();
          if (drop && !isOpen) {
            drop.hidden = false;
            grp.classList.add('is-open');
            /* I filterarket staar grupperne under hinanden, og en gruppe langt
               nede folder ud UNDER skaermkanten — man trykker og der sker
               tilsyneladende ingenting. Her rulles gruppens egen linje op i
               toppen af arket, saa vaerdierne staar der man kigger. Paa desktop
               findes .plp__sheet-scroll ikke som rullefelt (display: contents),
               saa der sker intet. */
            var ark = grp.closest('.plp__sheet-scroll');
            if (ark && ark.scrollHeight > ark.clientHeight) {
              var top = grp.getBoundingClientRect().top - ark.getBoundingClientRect().top + ark.scrollTop;
              ark.scrollTo({ top: top, behavior: 'smooth' });
            }
          }
        });
      });
      var sortBtn = root.querySelector('[data-sort-toggle]');
      if (sortBtn) {
        var sortGroup = sortBtn.closest('.plp__sortgroup');
        var sortDrop = root.querySelector('[data-sort-drop]');
        sortBtn.addEventListener('click', function (e) {
          e.stopPropagation();
          var isOpen = sortDrop && !sortDrop.hidden;
          closeAll();
          if (sortDrop && !isOpen) { sortDrop.hidden = false; sortGroup.classList.add('is-open'); }
        });
      }
      document.addEventListener('click', function (e) { if (!e.target.closest('.plp__filterbar')) closeAll(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });
      root.querySelectorAll('[data-price-slider]').forEach(initPriceSlider);

      /* ===== Filterarket (kun telefon) =====
         Aabner og lukker den samme DOM som baren bruger paa desktop — se den
         lange begrundelse i snippets/filter-bar.liquid. Her er der kun tre ting
         der skal passes paa:

         1. `.plp__filterbar` er KLAEBENDE og faar `transform` naar den gemmer sig
            (.is-tucked). Et transformeret element bliver containing block for
            alt `position: fixed` indeni, saa arket ville lande INDE i baren i
            stedet for at daekke skaermen. `is-sheet-open` nulstiller baade
            klassen og transformen mens arket er aabent.
         2. Baren ligger paa z-index 20 og headeren paa 50. Arket skal over
            begge, saa baren loeftes mens det er aabent.
         3. Baggrunden maa ikke rulle bag arket. */
      var sheet = root.querySelector('[data-sheet]');
      if (sheet) {
        var sheetBar = sheet.closest('.plp__filterbar');
        var panel = sheet.querySelector('.plp__sheet-panel');
        var trigger = root.querySelector('[data-sheet-open]');
        var sidstFokus = null;
        var aabenSheet = function () {
          sidstFokus = document.activeElement;
          if (sheetBar) { sheetBar.classList.remove('is-tucked'); sheetBar.classList.add('is-sheet-open'); }
          sheet.classList.add('is-open');
          document.body.classList.add('har-filterark');
          if (trigger) trigger.setAttribute('aria-expanded', 'true');
          if (panel) { panel.setAttribute('role', 'dialog'); panel.setAttribute('aria-modal', 'true'); }
          var x = sheet.querySelector('.plp__sheet-x');
          if (x) x.focus();
        };
        var lukSheet = function () {
          sheet.classList.remove('is-open');
          if (sheetBar) sheetBar.classList.remove('is-sheet-open');
          document.body.classList.remove('har-filterark');
          if (trigger) trigger.setAttribute('aria-expanded', 'false');
          if (panel) { panel.removeAttribute('role'); panel.removeAttribute('aria-modal'); }
          closeAll();
          if (sidstFokus && sidstFokus.focus) sidstFokus.focus();
        };
        root.addEventListener('click', function (e) {
          if (e.target.closest('[data-sheet-open]')) { e.preventDefault(); aabenSheet(); return; }
          if (e.target.closest('[data-sheet-close]')) { e.preventDefault(); lukSheet(); }
        });
        document.addEventListener('keydown', function (e) {
          if (e.key === 'Escape' && sheet.classList.contains('is-open')) lukSheet();
        });
        /* Skifter man til desktop-bredde mens arket er aabent, skal tilstanden
           vaek — ellers ligger `har-filterark` og laaser sidens rulning fast paa
           en side hvor arket ikke findes. */
        if (window.matchMedia) {
          var mq = window.matchMedia('(min-width: 750px)');
          var vedSkift = function (ev) { if (ev.matches && sheet.classList.contains('is-open')) lukSheet(); };
          if (mq.addEventListener) mq.addEventListener('change', vedSkift);
          else if (mq.addListener) mq.addListener(vedSkift);
        }
      }
    });
  }

  window.EndorseInitPriceSlider = initPriceSlider;

  /* ===== Folder heroen ud igen efter et sideskift =====
     Modstykket til .plp-paged (se den lange begrundelse i layout/theme.liquid).
     Siden er malet uden hero og servicebånd, så den stod rigtigt med det samme.
     Nu skal de tilbage — uden at noget på skærmen flytter sig.

     Højden måles som forskellen på dokumentets samlede højde før og efter. Det er
     med vilje ikke en sum af de to elementers højder: den slags regnestykke skal
     rettes hver gang nogen tilføjer et bånd, og glemmer man det, rykker siden.
     scrollHeight kender altid det rigtige tal.

     Alt sker i samme synkrone blok, så browseren kun når at male én gang. */
  function restorePagedChrome() {
    var html = document.documentElement;
    if (!html.classList.contains('plp-paged')) return;
    var boxes = document.querySelectorAll('.plp-paged-hide');
    if (!boxes.length) { html.classList.remove('plp-paged'); return; }

    /* ALT måles inden noget røres. Rækkefølgen er hele pointen: læser man først en
       højde EFTER at klassen er fjernet, tvinger man en omregning af en tilstand
       hvor indholdet er foldet ud men skærmen ikke er rullet endnu — og den
       mellemtilstand tæller med som layout-shift (målt: 0,40) selv om browseren
       aldrig maler den. Nu er der kun én omregning, til sidst. */
    var y = window.pageYOffset;
    var added = 0;
    for (var i = 0; i < boxes.length; i++) added += boxes[i].getBoundingClientRect().height;
    var plads = html.scrollHeight - window.innerHeight;   // hvor langt der kan rulles NU

    if (added <= 0) { html.classList.remove('plp-paged'); return; }

    if (y + added <= plads) {
      // Rul først, fold ud bagefter. Ingen af delene når skærmen hver for sig, fordi
      // begge sker i samme synkrone blok.
      window.scrollTo(0, y + added);
      html.classList.remove('plp-paged');
    } else {
      /* Sammenfoldet er dokumentet for kort til at rulle så langt — det sker på en
         sidste side med få varer. Så må det være den anden vej rundt, med den ene
         mellemtilstand det koster. Bedre end at lande et forkert sted. */
      html.classList.remove('plp-paged');
      window.scrollTo(0, y + added);
    }
  }

  /* ===== Filterbaren viger når man ruller ned =====
     Selve det klæbende og selve skjulet er CSS (se filter-bar.liquid). Her afgøres
     kun HVORNÅR klassen skal på. Tre ting gør reglen mere end "dy > 0":

     1. Baren må først gemme sig når den rent faktisk KLÆBER. Ellers ville den, mens
        den stadig ligger i sit naturlige leje midt på siden, blive skubbet 56px op
        og efterlade et hul i indholdet.
        Klæbetilstanden aflæses direkte af geometrien: en klæbende kasse har rect.top
        præcis lig sin egen `top` i det øjeblik den er nået frem. Det holder kun så
        længe der ikke er en transform på — derfor spørges der aldrig mens den er
        gemt, hvilket den logiske rækkefølge herunder sikrer.
     2. Der tælles px op i den aktuelle retning i stedet for at reagere på hvert
        eneste hændelse. Uden det blinker baren ved elastisk rulning og ved den lille
        modbevægelse en pegefinger laver når den slipper.
     3. En åben dropdown holder baren. Ellers ruller listen man sigter efter væk
        under fingeren. */
  function initStickyFilterBar() {
    var bars = document.querySelectorAll('.plp__filterbar');
    if (!bars.length) return;

    var NED = 10;   // px ned før den gemmer sig
    var OP = 6;     // px op før den kommer igen: skal være lettere end at gemme den
    var lastY = window.pageYOffset;
    var acc = 0;
    var holdUntil = 0;

    function pinnedTop(bar) { return parseFloat(window.getComputedStyle(bar).top) || 0; }

    function setTucked(v) {
      Array.prototype.forEach.call(bars, function (bar) {
        if (bar.classList.contains('is-tucked') === v) return;
        bar.classList.toggle('is-tucked', v);
      });
    }
    function anyTucked() {
      return Array.prototype.some.call(bars, function (b) { return b.classList.contains('is-tucked'); });
    }
    function anyOpen() {
      return Array.prototype.some.call(bars, function (b) {
        return !!b.querySelector('.plp__fgroup.is-open, .plp__sortgroup.is-open');
      });
    }
    function anyStuck() {
      return Array.prototype.some.call(bars, function (b) {
        return b.getBoundingClientRect().top <= pinnedTop(b) + 1;
      });
    }

    /* Kaldes udefra (plp-filter.js) før en programmeret rulning: den flytter siden
       langt på én gang, og uden en pause ville baren tolke det som at brugeren
       kigger videre og gemme sig midt i springet. */
    function show(holdMs) {
      setTucked(false);
      acc = 0;
      lastY = window.pageYOffset;
      holdUntil = Date.now() + (holdMs || 0);
    }
    window.EndorseShowFilterBar = show;

    var queued = false;
    window.addEventListener('scroll', function () {
      if (queued) return;
      queued = true;
      window.requestAnimationFrame(function () {
        queued = false;
        var y = window.pageYOffset;
        var dy = y - lastY;
        lastY = y;
        if (!dy) return;

        // Retningsskift nulstiller tælleren, ellers kan rystelser hobe sig op.
        if ((dy > 0) !== (acc > 0)) acc = 0;
        acc += dy;

        if (y <= 0) { setTucked(false); return; }
        if (Date.now() < holdUntil) return;
        if (anyOpen()) { setTucked(false); return; }

        if (acc <= -OP) { setTucked(false); return; }
        if (acc >= NED && !anyTucked() && anyStuck()) setTucked(true);
      });
    }, { passive: true });

    // Rører man baren, skal den blive. Et klik på et filter må ikke ende med at
    // knappen forsvinder mens dropdownen åbner.
    Array.prototype.forEach.call(bars, function (bar) {
      bar.addEventListener('click', function () { show(0); });
    });
  }

  /* ===== Grid fillers =====
     The product grid runs gap:0 and paints its rules with per-card right+bottom
     hairlines, so a trailing empty cell has no lines and reads as a hole.
     On desktop there ISN'T one: 25 products over 5 columns is 5 exact rows. This
     closes the row at the narrower breakpoints (2/3/4 columns leave one over) and
     wherever no further product exists — a collection's last page, a filtered
     result set. The column count is a media query, not something Liquid can know,
     so we measure the resolved grid-template-columns. Re-runs on resize. */
  function syncGridFillers(grid) {
    if (!grid) return;
    Array.prototype.forEach.call(grid.querySelectorAll('.product-card--filler'), function (el) {
      el.parentNode.removeChild(el);
    });
    var cs = window.getComputedStyle(grid);
    if (cs.display.indexOf('grid') === -1) return;
    var cols = cs.gridTemplateColumns.split(' ').filter(Boolean).length;
    if (cols < 2) return;
    var cards = grid.querySelectorAll('.product-card').length;   // fillers already gone

    /* Kampagnefelter spænder over flere celler, så antallet af ELEMENTER holder
       ikke længere som mål for hvor mange celler der er brugt: et 2x2 er ét
       element og fire celler. Findes modulet, lader vi det regne på arealet fra
       sin egen grid-simulering. Findes det ikke — alle andre gitre på sitet —
       er modulo-regnestykket stadig det rigtige. */
    var need;
    if (window.EndorseCampaigns && grid.querySelector('.camp-tile')) {
      need = window.EndorseCampaigns.fillersNeeded(grid, cols);
    } else {
      need = cards ? (cols - (cards % cols)) % cols : 0;
    }
    for (var i = 0; i < need; i++) {
      var cell = document.createElement('div');
      cell.className = 'product-card product-card--filler';
      cell.setAttribute('aria-hidden', 'true');
      grid.appendChild(cell);
    }
  }

  function initGridFillers() {
    var grids = document.querySelectorAll('[data-grid]');
    if (!grids.length) return;
    var run = function () { Array.prototype.forEach.call(grids, syncGridFillers); };
    run();
    var t;
    window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(run, 150); });
  }

  // plp-filter.js re-renders the grid client-side; it calls this after every render.
  window.EndorseSyncGrid = syncGridFillers;

  /* ===== Ønskelisten (likes) =====
     Hjertet på produktkortet var pynt siden design-porten; nu er det knappen her.
     Tilstanden er et array af produkt-handles i localStorage['endorse-likes']
     (endorse-*-konventionen, try/catch fordi storage kan kaste i private mode).
     Kortene bærer data-handle (snippets/product-card.liquid + cardHTML i
     plp-filter.js — hold de to i takt).

     Klikket er DELEGERET på document: gitteret genbygges med innerHTML ved al
     filtrering, så per-element listeners ville dø ved første filter. Af samme
     grund males .is-liked på server-renderede kort ved load (forside, PDP-gitre,
     ufiltreret PLP), mens JS-byggede kort får klassen inline i cardHTML.

     Hvert toggle spejles (debounce) til R2 via endorse-admin, nøglet på samme
     endorse-vid som besøgs-beaconen i theme.liquid — anonym profil pr. browser,
     ingen login (Mikkels valg 2026-08-31). Hele sættet sendes hver gang, så
     serveren aldrig skal flette. text/plain-blob af samme grund som /api/t:
     application/json udløser CORS-preflight og beaconen droppes. En fejl her må
     ALDRIG kunne mærkes i butikken. */
  var LIKES_KEY = 'endorse-likes';
  function readLikes() {
    try {
      var raw = JSON.parse(localStorage.getItem(LIKES_KEY) || '[]');
      if (Object.prototype.toString.call(raw) !== '[object Array]') return [];
      return raw.filter(function (h) { return typeof h === 'string' && h; });
    } catch (e) { return []; }
  }
  var likesArr = readLikes();
  var likesSet = {};
  likesArr.forEach(function (h) { likesSet[h] = 1; });

  /* Samme nøgle og samme opskrift som theme.liquid — den der kommer først, opretter.
     `opret` er IKKE pynt: uden samtykke må id'et hverken oprettes eller læses til
     måling, for selve skrivningen i localStorage er indgrebet efter
     cookiebekendtgørelsen § 3. Kaldes derfor kun med true inde i
     EndorseConsent.naarTilladt. Se den lange note i theme.liquid. */
  function likesVid(opret) {
    try {
      var k = 'endorse-vid', v = localStorage.getItem(k);
      if (!v && opret) { v = Math.random().toString(36).slice(2, 12); localStorage.setItem(k, v); }
      return v || '';
    } catch (e) { return ''; }
  }

  /* Debounce ALENE taber skrivninger: navigerer man væk inden for vinduet, dør
     setTimeout-timeren med siden, og et like → klik-videre-på-varen (det mest
     almindelige flow) ville aldrig nå R2. Målt i den første E2E-probe: nul
     beacon-dokumenter efter 15 grønne UI-tjek. Derfor et dirty-flag plus flush
     på pagehide/visibilitychange — det øjeblik sendBeacon er opfundet til. */
  var likesSyncT;
  var likesDirty = false;
  /* SPEJLINGEN ER DELT I TO, og skellet er juridisk og ikke teknisk (2026-09-08).
     Ønskelisten i localStorage bliver hvor den er og spørger ikke om noget: kunden
     har selv trykket på hjertet, så den er strengt nødvendig for den funktion
     kunden bad om.

       LOGGET IND  -> spejlingen ER tjenesten (ønskelisten på tværs af enheder).
                      Serveren skriver til profilen ud fra tokenet, så browser-id'et
                      er der ikke brug for, og der spørges ikke om samtykke.
       IKKE LOGGET -> den eneste modtager er HQ's oversigt over top-likede, og
                      nøglen er et vedvarende browser-id. Det er måling, og den
                      kræver samtykke. Uden samtykke sendes der intet, og id'et
                      bliver ikke oprettet.

     `likesDirty` bliver STÅENDE når der ikke er samtykke, så et senere ja stadig
     kan få listen med. Flushet på pagehide prøver bare igen og går tomt ud. */
  function likesSend() {
    if (!likesDirty) return;
    clearTimeout(likesSyncT);
    try {
      if (!navigator.sendBeacon) return;
      var likes = likesArr.slice(0, 500);
      var url = 'https://endorse.fcsolutions.dk/api/likes';
      var send = function (payload) {
        navigator.sendBeacon(url, new Blob([JSON.stringify(payload)], { type: 'text/plain' }));
        likesDirty = false;
      };
      // profileDoc er var-hoistet og sat ved load, længe før første beacon.
      if (profileDoc) { send({ likes: likes, t: profileDoc.t }); return; }
      var c = window.EndorseConsent;
      if (!c || !c.tilladt()) return;
      var vid = likesVid(true);
      if (!vid) return;
      send({ v: vid, likes: likes });
    } catch (e) { /* beacon-fejl må aldrig larme i butikken */ }
  }
  function likesSync() {
    likesDirty = true;
    clearTimeout(likesSyncT);
    likesSyncT = setTimeout(likesSend, 800);
  }
  addEventListener('pagehide', likesSend);
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'hidden') likesSend();
  });

  /* Samme vare kan stå i flere gitre på én side (PLP + "passer til"), så der
     males altid på ALLE kort, ikke kun det der blev klikket. */
  function likesPaintBtn(btn, h) {
    var on = !!likesSet[h];
    btn.classList.toggle('is-liked', on);
    btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    btn.setAttribute('aria-label', on ? 'Fjern fra ønskelisten' : 'Tilføj til ønskelisten');
  }
  function likesPaint(scope) {
    var root = scope || document;
    var cards = root.querySelectorAll('.product-card[data-handle]');
    Array.prototype.forEach.call(cards, function (card) {
      var btn = card.querySelector('.product-card__heart');
      if (!btn) return;
      likesPaintBtn(btn, card.getAttribute('data-handle'));
    });
    /* Produktsidens hjerte ved koebeknappen (sections/product.liquid, .pdp__wish)
       baerer selv sin handle. Var pynt indtil 2026-09-12. */
    Array.prototype.forEach.call(root.querySelectorAll('.pdp__wish[data-handle]'), function (btn) {
      likesPaintBtn(btn, btn.getAttribute('data-handle'));
    });
    // Hjertets tal i headeren følger med hver maling (load, toggle, server-sync).
    syncHeaderState();
  }

  window.EndorseLikes = {
    has: function (h) { return !!likesSet[h]; },
    all: function () { return likesArr.slice(); },
    count: function () { return likesArr.length; },
    paint: likesPaint,
    toggle: function (h) {
      var on;
      if (likesSet[h]) {
        delete likesSet[h];
        var at = likesArr.indexOf(h);
        if (at > -1) likesArr.splice(at, 1);
        on = false;
      } else {
        likesSet[h] = 1;
        likesArr.push(h);
        on = true;
      }
      try { localStorage.setItem(LIKES_KEY, JSON.stringify(likesArr)); } catch (e) {}
      likesSync();
      return on;
    },
  };

  /* ===== Profilen (rigtige profiler, e-mail + engangskode) =====
     Tokenet er stateless (pid.exp.sig, udstedt af endorse-admin) og bor i
     localStorage['endorse-profile'] = { t, email }. Profilsiden
     (sections/profil.liquid) sætter/rydder det via EndorseProfile; her ejes
     kun tilstanden og side-load-syncen.

     Sync-semantik (dokumenteret beslutning): login = UNION (serverside),
     derefter last-write-wins. Ved side-load med token hentes profilens likes
     ÉN gang pr. session (sessionStorage-flag) og overskriver enhedens — den
     seneste enhed der skrev, ejer listen. To enheder samtidig = sidste vinder;
     accepteret for en ønskeliste. */
  var PROFILE_KEY = 'endorse-profile';
  function readProfileDoc() {
    try {
      var p = JSON.parse(localStorage.getItem(PROFILE_KEY) || 'null');
      return p && typeof p.t === 'string' && p.t ? p : null;
    } catch (e) { return null; }
  }
  var profileDoc = readProfileDoc();

  function setLikesFromServer(arr) {
    likesArr = [];
    likesSet = {};
    (arr || []).forEach(function (h) {
      if (typeof h === 'string' && h && !likesSet[h]) { likesSet[h] = 1; likesArr.push(h); }
    });
    try { localStorage.setItem(LIKES_KEY, JSON.stringify(likesArr)); } catch (e) {}
    likesPaint();
    document.dispatchEvent(new CustomEvent('endorse:likes-changed', { detail: { fromServer: true } }));
  }

  window.EndorseProfile = {
    loggedIn: function () { return !!profileDoc; },
    token: function () { return profileDoc ? profileDoc.t : ''; },
    email: function () { return profileDoc ? profileDoc.email || '' : ''; },
    setLikes: setLikesFromServer,
    set: function (t, email) {
      profileDoc = { t: t, email: email };
      try { localStorage.setItem(PROFILE_KEY, JSON.stringify(profileDoc)); } catch (e) {}
      syncHeaderState();
    },
    clear: function () {
      profileDoc = null;
      try { localStorage.removeItem(PROFILE_KEY); } catch (e) {}
      try { sessionStorage.removeItem('endorse-profile-synced'); } catch (e) {}
      syncHeaderState();
    },
  };

  /* Headerens synlige tilstand — standardmønstret (Matas/Lyko): hjertets tal
     og person-ikonets label ("Log ind" -> e-mail-prefix når man er inde).
     Serveren render'er den udloggede stand; browseren ejer sandheden, så den
     males på her — på ALLE sider, også forsiden. */
  function syncHeaderState() {
    var n = likesArr.length;
    Array.prototype.forEach.call(document.querySelectorAll('[data-likes-badge]'), function (b) {
      b.textContent = n;
      b.hidden = n === 0;
    });
    var name = '';
    if (profileDoc && profileDoc.email) name = String(profileDoc.email).split('@')[0].slice(0, 12);
    Array.prototype.forEach.call(document.querySelectorAll('[data-profile-label]'), function (l) {
      l.textContent = name || 'Log ind';
    });
    Array.prototype.forEach.call(document.querySelectorAll('[data-header-profile]'), function (a) {
      a.classList.toggle('is-ind', !!profileDoc);
    });
  }

  function initProfile() {
    syncHeaderState();
    if (!profileDoc) return;
    var done = '1';
    try { done = sessionStorage.getItem('endorse-profile-synced') || ''; } catch (e) { /* storage kastede: spring sync over */ }
    if (done) return;
    try { sessionStorage.setItem('endorse-profile-synced', '1'); } catch (e) {}
    // text/plain holder kaldet preflight-frit; ruten læser body som tekst.
    fetch('https://endorse.fcsolutions.dk/api/profile/sync', {
      method: 'POST',
      headers: { 'Content-Type': 'text/plain' },
      body: JSON.stringify({ t: profileDoc.t }),
    }).then(function (r) { return r.json(); }).then(function (d) {
      if (d && d.ok && d.likes) setLikesFromServer(d.likes);
      else if (d && d.ok === false) window.EndorseProfile.clear();   // dødt token/slettet profil
    }).catch(function () { /* offline er fint — localStorage bærer */ });
  }

  function initLikes() {
    likesPaint();
    document.addEventListener('click', function (e) {
      if (!e.target.closest) return;
      var btn = e.target.closest('.product-card__heart, .pdp__wish');
      if (!btn) return;
      var h = btn.getAttribute('data-handle');
      if (!h) {
        var card = btn.closest('.product-card');
        h = card && card.getAttribute('data-handle');
      }
      if (!h) return;
      e.preventDefault();
      e.stopPropagation();
      var on = window.EndorseLikes.toggle(h);
      likesPaint();
      // plp-filter.js lytter: står favorit-filteret på, skal gitteret tegnes om.
      document.dispatchEvent(new CustomEvent('endorse:likes-changed', { detail: { handle: h, liked: on } }));
    });
  }

  /* De vandret rulbare tabeller skal kunne naas med et tastatur (WCAG 2.1.1).
     `.cmod--table` har `overflow-x: auto`, og et element med overflow kan kun
     rulles med piletasterne hvis det kan få fokus. axe-core flagede den på
     kategorisiden i 390px: "Scrollable region must have keyboard access".

     Fixet ligger HER og ikke i indholdet, og det er en bevidst beslutning.
     Wrapperen skrives af kategoriteksterne, guiderne og cookiepolitikken, altså
     i `body_html` og i metafelter. Havde rettelsen ligget der, skulle 38
     kategoritekster og 9 guider skrives om, og den næste tekst nogen skriver
     ville mangle den igen. Her rammer den alt, også bagud.

     `tabindex` sættes kun når indholdet faktisk er bredere end rammen: en
     tabstop der ikke ruller nogen steder er selv en fejl. */
  function initRulTabeller() {
    var vs = document.querySelectorAll('.cmod--table');
    Array.prototype.forEach.call(vs, function (v) {
      if (v.scrollWidth <= v.clientWidth + 1) return;
      if (!v.hasAttribute('tabindex')) v.setAttribute('tabindex', '0');
      if (!v.getAttribute('role')) v.setAttribute('role', 'region');
      if (!v.getAttribute('aria-label')) {
        var cap = v.querySelector('caption');
        var h = v.previousElementSibling;
        var navn = (cap && cap.textContent.trim())
          || (h && /^H[2-4]$/.test(h.tagName) && h.textContent.trim())
          || 'Tabel';
        v.setAttribute('aria-label', navn.slice(0, 80) + ', ruller til siden');
      }
    });
  }

  function init() {
    /* Først af alt: jo længere siden står sammenfoldet, jo længere er heroen væk
       fra en kunde der rullede op med det samme. */
    restorePagedChrome();
    initReveal();
    initCounters();
    initHeader();
    initFilterBars();
    initStickyFilterBar();
    initGridFillers();
    initLikes();
    initProfile();
    initRulTabeller();
    /* Bredden ændrer sig ved rotation og ved zoom, og så ændrer svaret på
       "ruller den?" sig. Billig nok at køre igen. */
    addEventListener('resize', initRulTabeller);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
